const THEME_MANAGER_THEME_KEY = "gx-eai-theme";

export type ThemeManagerAvailableThemes = "light" | "dark";

export const getTheme = (): ThemeManagerAvailableThemes | null =>
  localStorage.getItem(
    THEME_MANAGER_THEME_KEY
  ) as ThemeManagerAvailableThemes | null;

export const getThemePreferences = (): ThemeManagerAvailableThemes =>
  window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

export function storeTheme(theme: ThemeManagerAvailableThemes) {
  localStorage.setItem(THEME_MANAGER_THEME_KEY, theme);
}

export function setThemeInBrowser(theme: ThemeManagerAvailableThemes) {
  // Remove previous theme
  document.documentElement.classList.remove("light", "dark");

  // Set new theme
  document.documentElement.classList.add(theme);
}
